import {
  Building2,
  Layers,
  Grid3x3,
  Wrench,
  Tag,
  BookOpen,
  Settings,
  FolderTree,
  Map,
  MapPin,
} from 'lucide-react';
import { LayoutConfig } from '../../components/layout/types';

export const taxonomyLayoutConfig: LayoutConfig = {
  brandName: "Taxonomy",
  brandSubtitle: "Configuration",
  sidebarWidth: 288,
  headerHeight: "4rem",
  showLocationDropdown: false,
  showSearchBar: true,
  searchPlaceholder: "Search taxonomy...",
  showViewSwitcher: false,
  menuSections: [
    {
      label: "Taxonomy Types",
      defaultOpen: true,
      items: [
        {
          icon: MapPin,
          label: "Location Names",
          path: "/admin/taxonomy/location-names",
          color: "text-teal-600"
        },
        {
          icon: Map,
          label: "Location Categories",
          path: "/admin/taxonomy/location-categories",
          color: "text-emerald-600"
        },
        {
          icon: Building2,
          label: "Organization Types",
          path: "/admin/organization-types",
          color: "text-blue-600"
        },
        {
          icon: Grid3x3,
          label: "Organization Sections",
          path: "/admin/sections",
          color: "text-indigo-600"
        },
        {
          icon: Layers,
          label: "Service Categories",
          path: "/admin/service-types",
          color: "text-purple-600"
        },
        {
          icon: Wrench,
          label: "Service Names",
          path: "/admin/service-definitions",
          color: "text-violet-600"
        },
        {
          icon: Tag,
          label: "Topic Categories",
          path: "/admin/topic-types",
          color: "text-fuchsia-600"
        },
        {
          icon: BookOpen,
          label: "Topic Names",
          path: "/admin/topics",
          color: "text-pink-600"
        },
        {
          icon: Settings,
          label: "Field Configurations",
          path: "/admin/field-configs",
          color: "text-rose-600"
        }
      ]
    }
  ]
};



